import { createAction } from '@reduxjs/toolkit';
import {
    IAddNewCard,
    ICreatePaymentIntent,
    IGetPublishableKey,
    IGetPublishableKeyResponse,
    IPaymentIntentResponse,
    IPaymentRailQuery,
    IPaymentRailResponse,
    IVerifyFlutterwavePurchasePayload,
    IVerifyFlutterwavePurchaseResult,
    IVerifyPaystackPurchasePayload,
    IVerifyPaystackPurchaseResult,
    types,
} from './types';
import { IPaymentCard } from '../../types/global/generic.types';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

export const addPaymentMethod = createAction<IAddNewCard>(types.ADD_PAYMENT_METHOD);
export const addPaymentMethodSuccess = createAction<IPaymentCard>(types.ADD_PAYMENT_METHOD_SUCCESS);
export const addPaymentMethodFail = createAction<IErrorType>(types.ADD_PAYMENT_METHOD_FAIL);

export const updatePaymentMethod = createAction<IGenericDocumentModifier>(types.UPDATE_PAYMENT_METHOD);
export const updatePaymentMethodSuccess = createAction<IPaymentCard>(types.UPDATE_PAYMENT_METHOD_SUCCESS);
export const updatePaymentMethodFail = createAction<IErrorType>(types.UPDATE_PAYMENT_METHOD_FAIL);

export const deletePaymentMethod = createAction<IGenericDocumentModifier>(types.DELETE_PAYMENT_METHOD);
export const deletePaymentMethodSuccess = createAction<IGenericDocumentModifier>(types.DELETE_PAYMENT_METHOD_SUCCESS);
export const deletePaymentMethodFail = createAction<IErrorType>(types.DELETE_PAYMENT_METHOD_FAIL);

export const getPaymentMethods = createAction(types.GET_PAYMENT_METHODS);
export const getPaymentMethodsSuccess = createAction<IPaymentCard[]>(types.GET_PAYMENT_METHODS_SUCCESS);
export const getPaymentMethodsFail = createAction<IErrorType>(types.GET_PAYMENT_METHODS_FAIL);

export const createPaymentIntent = createAction<ICreatePaymentIntent>(types.CREATE_PAYMENT_INTENT);
export const createPaymentIntentSuccess = createAction<IPaymentIntentResponse>(types.CREATE_PAYMENT_INTENT_SUCCESS);
export const createPaymentIntentFail = createAction<IErrorType>(types.CREATE_PAYMENT_INTENT_FAIL);

export const createPaymentIntentForPurchase = createAction<ICreatePaymentIntent>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE,
);
export const createPaymentIntentForPurchaseSuccess = createAction<IPaymentIntentResponse>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_SUCCESS,
);
export const createPaymentIntentForPurchasetFail = createAction<IErrorType>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_FAIL,
);

export const getPublishableKey = createAction<IGetPublishableKey>(types.GET_PUBLISHABLE_KEY);
export const getPublishableKeySuccess = createAction<IGetPublishableKeyResponse>(types.GET_PUBLISHABLE_KEY_SUCCESS);
export const getPublishableKeyFail = createAction<IErrorType>(types.GET_PUBLISHABLE_KEY_FAIL);

export const getPaymentRail = createAction<IPaymentRailQuery>(types.GET_PAYMENT_RAIL);
export const getPaymentRailSuccess = createAction<IPaymentRailResponse>(types.GET_PAYMENT_RAIL_SUCCESS);
export const getPaymentRailFail = createAction<IErrorType>(types.GET_PAYMENT_RAIL_FAIL);

export const fetchAdminPaymentRailCountries = createAction(types.FETCH_ADMIN_PAYMENT_RAIL_COUNTRIES);
export const fetchAdminPaymentRailCountriesSuccess = createAction<Record<string, unknown>>(
    types.FETCH_ADMIN_PAYMENT_RAIL_COUNTRIES_SUCCESS,
);
export const fetchAdminPaymentRailCountriesFail = createAction<IErrorType>(
    types.FETCH_ADMIN_PAYMENT_RAIL_COUNTRIES_FAIL,
);

export const saveAdminPaymentRailCountries = createAction<{
    assignments: Record<string, string[]>;
}>(types.SAVE_ADMIN_PAYMENT_RAIL_COUNTRIES);
export const saveAdminPaymentRailCountriesSuccess = createAction<Record<string, unknown>>(
    types.SAVE_ADMIN_PAYMENT_RAIL_COUNTRIES_SUCCESS,
);
export const saveAdminPaymentRailCountriesFail = createAction<IErrorType>(types.SAVE_ADMIN_PAYMENT_RAIL_COUNTRIES_FAIL);

export const assignAdminPaymentRailCountries = createAction<{
    rail: string;
    countries: string[];
}>(types.ASSIGN_ADMIN_PAYMENT_RAIL_COUNTRIES);
export const assignAdminPaymentRailCountriesSuccess = createAction<Record<string, unknown>>(
    types.ASSIGN_ADMIN_PAYMENT_RAIL_COUNTRIES_SUCCESS,
);
export const assignAdminPaymentRailCountriesFail = createAction<IErrorType>(
    types.ASSIGN_ADMIN_PAYMENT_RAIL_COUNTRIES_FAIL,
);

export const verifyPaystackPurchase = createAction<IVerifyPaystackPurchasePayload>(types.VERIFY_PAYSTACK_PURCHASE);
export const verifyPaystackPurchaseSuccess = createAction<IVerifyPaystackPurchaseResult>(
    types.VERIFY_PAYSTACK_PURCHASE_SUCCESS,
);
export const verifyPaystackPurchaseFail = createAction<IErrorType>(types.VERIFY_PAYSTACK_PURCHASE_FAIL);

export const verifyFlutterwavePurchase = createAction<IVerifyFlutterwavePurchasePayload>(
    types.VERIFY_FLUTTERWAVE_PURCHASE,
);
export const verifyFlutterwavePurchaseSuccess = createAction<IVerifyFlutterwavePurchaseResult>(
    types.VERIFY_FLUTTERWAVE_PURCHASE_SUCCESS,
);
export const verifyFlutterwavePurchaseFail = createAction<IErrorType>(types.VERIFY_FLUTTERWAVE_PURCHASE_FAIL);

export const initializeFlutterwaveBillingCard = (payload: { callback_url?: string; currency?: string }) => ({
    type: types.INITIALIZE_FLUTTERWAVE_BILLING_CARD,
    payload,
});

export const verifyFlutterwaveBillingCard = (payload: {
    transaction_id?: string;
    tx_ref?: string;
    reference?: string;
}) => ({
    type: types.VERIFY_FLUTTERWAVE_BILLING_CARD,
    payload,
});
